import { Reducer } from 'redux';

// Types
import { IntegrationFenceState, IntegrationFenceTypes } from './types';

const INITIAL_STATE: IntegrationFenceState = {
  integrationFenceData: {
    id: '',
    name: '',
    bounds: [],
    integration: null,
    createdAt: null,
    updatedAt: null,
  },
  integrationFenceList: [],
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<IntegrationFenceState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // CASES LIST INTEGRATION FENCE
    case IntegrationFenceTypes.LIST_INTEGRATION_FENCES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        integrationFenceList: INITIAL_STATE.integrationFenceList,
      };
    case IntegrationFenceTypes.LIST_INTEGRATION_FENCES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        integrationFenceList: action.payload.integrationFenceList,
        totalCount: action.payload.totalCount,
      };
    case IntegrationFenceTypes.LIST_INTEGRATION_FENCES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        integrationFenceList: INITIAL_STATE.integrationFenceList,
      };

    // CASES GET INTEGRATION FENCE
    case IntegrationFenceTypes.GET_INTEGRATION_FENCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        integrationFenceData: INITIAL_STATE.integrationFenceData,
      };
    case IntegrationFenceTypes.GET_INTEGRATION_FENCE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        integrationFenceData: action.payload.integrationFenceData,
      };
    case IntegrationFenceTypes.GET_INTEGRATION_FENCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        integrationFenceData: INITIAL_STATE.integrationFenceData,
      };

    // CASES CREATE INTEGRATION FENCE
    case IntegrationFenceTypes.CREATE_INTEGRATION_FENCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        integrationFenceData: INITIAL_STATE.integrationFenceData,
      };
    case IntegrationFenceTypes.CREATE_INTEGRATION_FENCE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        integrationFenceData: action.payload.integrationFenceData,
      };
    case IntegrationFenceTypes.CREATE_INTEGRATION_FENCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        integrationFenceData: INITIAL_STATE.integrationFenceData,
      };

    // CASES UPDATE INTEGRATION FENCE
    case IntegrationFenceTypes.UPDATE_INTEGRATION_FENCE_REQUEST:
      return { ...state, loading: true, error: false };
    case IntegrationFenceTypes.UPDATE_INTEGRATION_FENCE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        integrationFenceData: action.payload.integrationFenceData,
      };
    case IntegrationFenceTypes.UPDATE_INTEGRATION_FENCE_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE INTEGRATION FENCE
    case IntegrationFenceTypes.DELETE_INTEGRATION_FENCE_REQUEST:
      return { ...state, loading: true, error: false };
    case IntegrationFenceTypes.DELETE_INTEGRATION_FENCE_SUCCESS:
      return { ...state, loading: false, error: false };
    case IntegrationFenceTypes.DELETE_INTEGRATION_FENCE_FAILURE:
      return { ...state, loading: false, error: false };

    default:
      return state;
  }
};

export default reducer;
